module.exports = __webpack_public_path__ + "static/media/1POLICY42.6fdc717b.jpg";